import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { WebButton } from './web-button';
import { useRootStore } from '../../../providers/root-store-provider';
import { routes } from '../../../config/routes';

type SignupButtonProps = Omit<React.ComponentProps<typeof WebButton>, 'href' | 'onClick' | 'nativeLink'>;

/** Registration for guests; a useful app destination for existing accounts. */
export const SignupButton: React.FC<SignupButtonProps> = observer(({ children, ...props }) => {
    const { t } = useTranslation();
    const { cookieService, authStore } = useRootStore();
    const loggedIn = cookieService.hasJwtToken();

    return (
        <WebButton
            {...props}
            nativeLink={loggedIn}
            href={loggedIn ? routes.app.index : undefined}
            onClick={loggedIn ? undefined : () => authStore.authDialogStore.setSignupActive()}
        >
            {loggedIn ? t('pages.layout.header.goToApp') : children}
        </WebButton>
    );
});
